import { createContext, useContext } from 'react';

import type { CartEntryObject } from '@fhs-legacy/frontend/src/utils/menu';

type MenuLayoutContextType = {
  onUpdate: (cartEntry: CartEntryObject) => void;
  isEditingThisItem: boolean;
  addText: string;
};

const menuLayoutContext = createContext<MenuLayoutContextType | null>(null);

export const MenuLayoutProvider = menuLayoutContext.Provider;

export function useMenuLayout() {
  const context = useContext(menuLayoutContext);

  if (!context) {
    throw new Error('Must consume `useMenuLayout` with a MenuLayoutProvider');
  }

  return context;
}
